var triggerQualtrics = function (step) {
    var _a, _b, _c, _d, _e, _f, _g;
    (_b = (_a = window.QSI) === null || _a === void 0 ? void 0 : _a.API) === null || _b === void 0 ? void 0 : _b.unload();
    (_d = (_c = window.QSI) === null || _c === void 0 ? void 0 : _c.API) === null || _d === void 0 ? void 0 : _d.load();
    window._qsie = window._qsie || [];
    (_e = window._qsie) === null || _e === void 0 ? void 0 : _e.push(step);
    (_g = (_f = window.QSI) === null || _f === void 0 ? void 0 : _f.API) === null || _g === void 0 ? void 0 : _g.run();
};
export default triggerQualtrics;
//# sourceMappingURL=triggerQualtrics.js.map